<template>
  <div class="overflow-x-hidden relative">
    <div class="pt-16 border-b-2"></div>

    <div class="w-full">
      <div class="flex flex-row w-full mt-16">
        <div class="flex col w-1/2 pr-1 sm:pr-0">
          <div class="text-xl lg:text-3xl font-semibold">
            Booking #{{ booking.number }}
          </div>
        </div>
        <div class="flex-col w-1/2 pl-2 sm:pl-0">
          <div class="flex flex-row-reverse pt-1">
            <a
              href=""
              class="max-w-2xs w-full lg:w-19/20 text-center text-sm text-blue-400 font-semibold py-3 px-3 border border-blue-400 rounded-full hover:bg-blue-400 hover:text-white focus:outline-none"
              >Track another booking</a
            >
          </div>
        </div>
      </div>
      <div class="flex flex-row w-full mt-12">
        <div class="flex-col w-5/12 lg:w-6/20">
          <div class="lg:pl-16">
            <div class="border-b-4 border-blue-400"></div>
            <div class="mt-4 flex">
              <div class="w-2/12 flex-col mt-1">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 14.6666V1.33331"
                    stroke="#111111"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.3335 5.99998L8.00016 1.33331L12.6668 5.99998"
                    stroke="#111111"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                class="pl-2 flex-col w-10/12 inline-block font-semibold lg:text-lg"
              >
                Pickup Location
              </div>
            </div>

            <div
              v-if="showBooking"
              class="pickup mt-6 text-sm font-semibold lg:text-lg"
            >
              {{ pickupLocation.address.suburb }}<br />
              {{ pickupLocation.address.city }}
            </div>
            <div
              v-if="!showBooking"
              class="pickup mt-6 text-sm font-semibold lg:text-lg"
            >
              {{ pickupLocation.address.suburb }}<br />
              {{ pickupLocation.address.city }}
            </div>

            <div v-if="showBooking" class="mt-2 text-sm text-gray-600">
              <div>{{ pickupLocation.address.post_code }}</div>
            </div>
          </div>
        </div>

        <div class="flex-col w-2/12 lg:w-8/20"></div>

        <div class="flex-col w-5/12 lg:w-6/20">
          <div class="lg:pr-16">
            <div class="delivery-line border-b-4 border-teal-400"></div>
            <div class="mt-4 flex justify-end ">
              <div class="w-2/12 flex-col text-right mt-1">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 1.33335L8 14.6667"
                    stroke="#111111"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.6665 10L7.99984 14.6667L3.33317 10"
                    stroke="#111111"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                class="pl-2 text-right flex-colw-10/12 inline-block lg:text-lg font-semibold"
              >
                Delivery Location
              </div>
            </div>

            <div
              v-if="showBooking"
              class="mt-6 text-sm font-semibold text-right lg:text-lg"
            >
              {{ deliveryLocation.address.suburb }}<br />
              {{ deliveryLocation.address.city }}
            </div>
            <div
              v-if="!showBooking"
              class="mt-6 text-sm font-semibold text-right lg:text-lg"
            >
              {{ deliveryLocation.address.suburb }}<br />
              {{ deliveryLocation.address.city }}
            </div>

            <div
              v-if="showBooking"
              class="mt-2 text-right text-sm text-gray-600"
            >
              <div>{{ deliveryLocation.address.post_code }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <booking-status-step
      :statusStep="bookingStatusStep"
      :carrier="bookingCarrier"
      :times="times"
    ></booking-status-step>

    <div class="lg:flex lg:flex-row-reverse w-full">
      <div
        class="mt-10 lg:mt-12 w-full lg:w-14/20 text-center lg:ml-16 lg:pr-16"
      >
        <directions-map
          v-if="!isLoading"
          :max-zoom="10"
          :noTooltips="!showBooking"
          :origin="mapData.pickup"
          :destination="mapData.delivery"
          :height="500"
          :in-transit="inTransit"
          :latest-point="latestPoint"
          :movements="booking.movements"
        ></directions-map>
      </div>

      <div class="mt-5 lg:mt-12 w-full lg:w-6/20 text-center lg:ml-16">
        <freight-movement-timeline
          :timeline-items="timelineItems"
        ></freight-movement-timeline>
      </div>
    </div>

    <!-- <div
      v-if="showBooking"
      id="freight-table"
      class="mt-10 lg:mt-16 text-center overflow-x-auto"
    >
      <freights-table
        :has-dgs="booking.is_dg"
        :table-data="freights"
      ></freights-table>
    </div> -->

    <div class="text-base pt-6 relative">
      For more detail, please
      <a href="/login" class="text-info">
        Login
      </a>
      or
      <a href="/contact" class="text-info">
        contact us </a
      >.
    </div>

    <div
      class="absolute top-0 h-full w-full bg-white text-blue-400 flex justify-center"
      v-if="isLoading"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-64 h-64"
        viewBox="0 0 100 100"
      >
        <path
          fill="currentColor"
          d="M73 50c0-12.7-10.3-23-23-23S27 37.3 27 50m3.9 0c0-10.5 8.5-19.1 19.1-19.1S69.1 39.5 69.1 50"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            dur="1s"
            from="0 50 50"
            to="360 50 50"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>
  </div>
</template>

<script>
import BookingStatusStep from "../../components/steps/GuestBookingStatus";
import LocationCard from "../../components/cards/Location";
import FreightsTable from "../../components/tables/GuestFreightLines";
import FreightMovementTimeline from "../../components/timelines/GuestFreightMovement";
import DirectionsMap from "../../components/maps/Directions";
import axios from "axios";

export default {
  // Do not forget this little guy
  name: "GuestBookingDetails",
  // share common functionality with component mixins
  mixins: [],
  // compose new components
  extends: {},
  // component properties/variables
  props: ["trackingNumber", "showBooking"],
  // variables
  data() {
    return {
      halfBooking: "",
      booking: "",
      isLoading: true,
      bookingStatusStep: 0,
      times: {
        book: "",
        pickup: "",
        delivery: ""
      },
      bookingCarrier: "Pending",
      pickupLocation: {
        title: "pickup",
        name: "",
        address: "",
        times: [],
        ref: ""
      },
      deliveryLocation: {
        title: "delivery",
        name: "",
        address: "",
        times: [],
        ref: ""
      },
      freights: [],
      mapData: {
        center: {
          lat: "",
          lng: ""
        },
        pickup: {
          lat: "",
          lng: ""
        },
        delivery: {
          lat: "",
          lng: ""
        },
        latestPoint: {
          lat: "",
          lng: ""
        }
      },
      timelineItems: [],

      colourCycle: ["#ED8936", "#ECC94B", "#9F7AEA"],
      colourStage: 0,
      pickedUpColour: false
    };
  },
  computed: {
    inTransit() {
      if (
        this.booking.latestEroadLocation &&
        this.booking.latestEroadLocation.data.last_location
      ) {
        return true;
      }

      return false;
    },

    latestPoint() {
      if (!this.inTransit) {
        return null;
      }

      return {
        lat: this.booking.latestEroadLocation.data.last_location.lat,
        lng: this.booking.latestEroadLocation.data.last_location.lng
      };
    }
  },
  // when component uses other components
  components: {
    BookingStatusStep,
    LocationCard,
    FreightsTable,
    FreightMovementTimeline,
    DirectionsMap
  },
  // methods
  methods: {
    mapBookingStatus() {
      this.times.book = this.booking.placed_at;
      const statusId = this.booking.status_id;
      let stepId = 0;
      if (statusId === 3) {
        stepId = 1;
      }
      if (statusId === 4) {
        stepId = 2;
      }
      if (statusId === 5) {
        stepId = 4;
      }
      if (statusId === 9) {
        stepId = 5;
      }
      this.bookingStatusStep = stepId;
      this.bookingCarrier = this.booking.carrier;
    },
    mapPickupLocation() {
      this.pickupLocation.name = this.booking.pickupLocation.data.name;
      this.pickupLocation.address = this.booking.pickupLocation.data.address.data;
      this.pickupLocation.ref = this.booking.sender_ref;
      if (this.booking.pickup_at) {
        const time = {
          prefix: "Pickup After",
          dateTime: this.booking.pickup_at
        };
        this.pickupLocation.times.push(time);
      }
      if (this.booking.pickup_before) {
        const time = {
          prefix: "Pickup Before",
          dateTime: this.booking.pickup_before
        };
        this.pickupLocation.times.push(time);
      }
    },
    mapDeliveryLocation() {
      this.deliveryLocation.name = this.booking.deliveryLocation.data.name;
      this.deliveryLocation.address = this.booking.deliveryLocation.data.address.data;
      this.deliveryLocation.ref = this.booking.receiver_ref;
      if (this.booking.deliver_at) {
        const time = {
          prefix: "Delivery By",
          dateTime: this.booking.deliver_at
        };
        this.deliveryLocation.times.push(time);
      }
    },
    mapFreight() {
      const that = this;
      // console.log("hi");

      this.booking.lines.data.forEach(function(line) {
        const freight = {
          quantity: line.quantity,
          packageType: line.packageType.data.name,
          typeOfGoods: line.goodsType.data.name,
          description: line.description,
          weight: Number.parseInt(line.weight),
          volume: line.volume,
          dgLines: line.dgLines,
          _expanded: line.dgLines.data.length > 0, //show dgLines when the freight is dg
          _disableExpand: line.dgLines.data.length < 1
        };
        that.freights.push(freight);
      });
    },
    mapMapData() {
      this.mapData.pickup.lat = Number.parseFloat(
        this.booking.pickupLocation.data.address.data.latitude
      );
      this.mapData.pickup.lng = Number.parseFloat(
        this.booking.pickupLocation.data.address.data.longitude
      );
      this.mapData.delivery.lat = Number.parseFloat(
        this.booking.deliveryLocation.data.address.data.latitude
      );
      this.mapData.delivery.lng = Number.parseFloat(
        this.booking.deliveryLocation.data.address.data.longitude
      );
    },
    mapMovement() {
      if (typeof this.booking.movements != "undefined") {
        const that = this;
        let transitStopName = "";
        this.booking.movements.data.forEach(function(movement) {
          const timelineItem = {
            time: movement.time,
            content: ""
          };
          if (that.colourStage == 3) {
            that.colourStage = 0;
          }
          if (movement.type_id == 5) {
            timelineItem.content =
              "Allocated to truck [" +
              (movement.truck_plate === null
                ? "unknown"
                : movement.truck_plate) +
              "]";
            if (!that.pickedUpColour) {
              timelineItem.colour = "#63B3ED";
            } else {
              timelineItem.colour = that.colourCycle[that.colourStage];
              that.colourStage++;
            }
          }
          if (movement.type_id == 1) {
            timelineItem.content = "Picked up";
            that.times.pickup = movement.time;
            timelineItem.colour = "#63B3ED";
            that.pickedUpColour = true;
          }
          if (movement.type_id == 2) {
            timelineItem.content = "Delivered";
            that.times.delivery = movement.time;
            timelineItem.type = "delivery";
            timelineItem.colour = "#4FD1C5";
          }

          if (movement.type_id == 3) {
            const depotName =
              movement.name == undefined ? "Depot" : movement.name;
            timelineItem.content = "Uplifted | ";
            timelineItem.location = depotName;
            timelineItem.colour = that.colourCycle[that.colourStage];
            that.colourStage++;
          }
          if (movement.type_id == 4) {
            const depotName =
              movement.name == undefined ? "Depot" : movement.name;
            timelineItem.content = "Offloaded | ";
            timelineItem.location = depotName;
            timelineItem.colour = that.colourCycle[that.colourStage];
            that.colourStage++;
          }

          if (movement.type_id == 7) {
            timelineItem.content = "Tracker Linked To Booking";
          }

          if (movement.type_id == 8) {
            timelineItem.content =
              "Arrived at transit stop at " + movement.name;
            transitStopName = movement.name;
          }

          if (movement.type_id == 9) {
            timelineItem.content = "Left transit stop at " + transitStopName;
          }

          if (movement.type_id == 10) {
            timelineItem.content = "Tracker Unlinked From Booking";
          }

          if (movement.source_id == 6) {
            timelineItem.content =
              "Scanned as " +
              (movement.type_id == 1 ? "picked up" : "offloaded") +
              (movement.name != null ? " at " + movement.name : "");
          }

          if (timelineItem.content) {
            that.timelineItems.push(timelineItem);
          }
          // console.log(that.timelineItems);
        });
      }
    }
  },
  watch: {},
  // component Lifecycle hooks
  beforeCreate() {},
  created() {
    this.isLoading = true;
    if (this.showBooking) {
      axios
        .get("/tracking/bookings/" + this.trackingNumber + "?t=" + Date.now())
        .then(response => {
          this.booking = response.data.data;
          this.mapBookingStatus();
          this.mapPickupLocation();
          this.mapDeliveryLocation();
          this.mapFreight();
          this.mapMapData();
          this.mapMovement();
        })
        .catch(e => {
          this.$message.error({
            content:
              "Sorry, something is not working correctly. Please contact with Freighthub to get booking details.",
            duration: 10,
            closable: true
          });
        })
        .then(() => {
          this.isLoading = false;
        });
    } else {
      axios
        .get("/tracking/bookings/" + this.trackingNumber)
        .then(response => {
          this.booking = response.data.data;
          this.mapBookingStatus();
          this.mapPickupLocation();
          this.mapDeliveryLocation();
          this.mapMapData();
          this.mapMovement();
        })
        .catch(e => {
          this.$message.error({
            content:
              "Sorry, something is not working correctly. Please contact with Freighthub to get booking details.",
            duration: 10,
            closable: true
          });
        })
        .then(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {},
  filters: {
    numFilter(value) {
      let realVal = Number(value).toFixed(2);
      return Number(realVal);
    }
  }
};
</script>

<style>
#freight-table::-webkit-scrollbar,
#freight-table::-webkit-scrollbar-thumb {
  appearance: none;
}

@media (max-width: 1000px) {
  ::-webkit-scrollbar:horizontal {
    height: 14px !important;
  }

  -webkit-scrollbar-track {
    display: block !important;
  }
}
#freight-table::-webkit-scrollbar {
  width: 6px !important;
  cursor: pointer !important;
  background: #edf2f7 !important;
  border-radius: 9999px !important;
}
#freight-table::-webkit-scrollbar-thumb {
  background: #a0aec0 !important;
  border-radius: 9999px !important;
}

a.text-info {
  color: steelblue;
}

a.text-info:hover {
  color: blue;
}
</style>
